// extracted by mini-css-extract-plugin
export default {"home":"HomeContainer-module_home__PoUPH"};